/**
 * StandKonturSaglayici.jsx — bir standın ÇİZİLMİŞ ana hattını yükler ve alt ağaca verir (backlog #710).
 *
 * ESKİSİ: şirket tarafındaki stand sayfaları ("Standı Gör", Proje Görselleri'nin dört köşe "göz" düğmesi, Kuşbakışı kutucuğu), onların
 * yönetici kopyası (StandOverviewDetailPage'in KrokiGrid'i) ve Talepler sayfasının Teknik sekmesi, her stand için aynı sabit L şeklini
 * çiziyordu; yalnızca Proje Beyanı sihirbazı (#676) gerçek ana hattı çiziyordu. ŞİMDİ: bu sayfalar aynı ana hattı
 * GET /stands/talepler/{standId}/drawn-walls üzerinden (standın PROJESİ olmasa da çalışır) okur ve standKroki.cizimKonturu ile çizilebilir hâle getirir.
 *
 * ⚠️ `kontur` null ise çağıran taraf eski sabit L şeklini çizer ve onu ÖRNEK ŞEKİL diye işaretler (StandKrokiCizimi): stand çizilmemiş,
 *    çizim eski (kenar başlangıçları yok) ya da bozuk olabilir; hiçbirinde yarım bir şekil çizilmez.
 * ⚠️ Cevap gelene kadar `yukleniyor` true'dur ve çağıran taraf ne L ne gerçek şekli çizer (önce L, sonra gerçek şeklin "sıçraması" olmasın).
 * ⚠️ İstek başarısız olursa (ağ, 4xx/5xx) sayfa bozulmaz: kontur null kalır, örnek şekil gösterilir.
 */
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { getStandDrawnWalls } from "../../services/standTalepService";
import { cizimKonturu } from "./standKroki";

const BOS = { veri: null, kontur: null, yukleniyor: false };

/**
 * @param {number|string|null} standId SAYISAL stand id'si
 * @param {{forceLive?: boolean, etkin?: boolean}} secenek `etkin` false (mock stand, id yok) → hiçbir şey istenmez, yukleniyor false
 * @returns {{veri: object|null, kontur: object|null, yukleniyor: boolean}}
 */
export function useStandKonturuYukle(standId, { forceLive = false, etkin = true } = {}) {
  const anahtar = etkin && standId != null && standId !== "" ? `${standId}|${forceLive ? 1 : 0}` : null;
  // Sonuç, hangi anahtar için geldiğiyle birlikte tutulur: stand değişince eski standın şekli bir an bile yeni standa çizilmez ve
  // efekt içinde senkron setState gerekmez.
  const [sonuc, setSonuc] = useState({ anahtar: null, veri: null });

  useEffect(() => {
    if (!anahtar) return undefined;
    let ignore = false;
    getStandDrawnWalls(standId, { forceLive })
      .then((veri) => { if (!ignore) setSonuc({ anahtar, veri }); })
      .catch(() => { if (!ignore) setSonuc({ anahtar, veri: null }); });
    return () => { ignore = true; };
  }, [anahtar, standId, forceLive]);

  const hazir = anahtar != null && sonuc.anahtar === anahtar;
  const veri = hazir ? sonuc.veri : null;
  const kontur = useMemo(() => cizimKonturu(veri), [veri]);
  const yukleniyor = anahtar != null && !hazir;
  return useMemo(() => ({ veri, kontur, yukleniyor }), [veri, kontur, yukleniyor]);
}

const StandKonturContext = createContext(BOS);

/** Alt ağaçtaki KrokiShape / KrokiGrid gibi çizen bileşenlere standın ana hattını verir (props zincirine gerek kalmasın diye). */
export function StandKonturSaglayici({ standId, forceLive = false, etkin = true, children }) {
  const durum = useStandKonturuYukle(standId, { forceLive, etkin });
  return <StandKonturContext.Provider value={durum}>{children}</StandKonturContext.Provider>;
}

/** Sağlayıcı yoksa BOS (kontur yok, yükleme yok): bileşen eskisi gibi örnek şekli çizer. */
export function useStandKonturu() {
  return useContext(StandKonturContext);
}
